var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('woot-reports',{key:"campaign-reports",attrs:{"type":"campaign","getter-key":"labels/getCampaignLabels","action-key":"labels/get","reportKeys":_vm.reportKeys,"download-button-label":_vm.$t('CAMPAIGN_REPORTS.DOWNLOAD_CAMPAIGN_REPORTS')}})}
var staticRenderFns = []

export { render, staticRenderFns }